<template>
  <div class="com-search_wrapper flex justify-between">
    <div>
      <el-form :inline="true" class="">
        <el-form-item :label="`${item.label}:`" v-for="item in columns" :key="item.prop">
          <el-input
            v-if="item.type === 'input'"
            v-model="searchValues[item.prop]"
            :placeholder="`请输入${item.label}`"
          ></el-input>
          <el-select
            v-if="item.type === 'select'"
            v-model="searchValues[item.prop]"
            :placeholder="`请选择${item.label}`"
            clearable
          >
            <template v-if="item.option.length">
              <el-option
                v-for="(opt, index) in item.option"
                :key="index + 1"
                :label="opt.label"
                :value="opt.value"
              />
            </template>
          </el-select>
          <el-date-picker
            v-if="item.type === 'date'"
            v-model="searchValues[item.prop]"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <com-region
            v-if="item.type === 'region'"
            :regionId.sync="searchValues[item.prop]"
          ></com-region>
          <template v-if="item.type === 'slot'">
            <slot :name="item.slotName" :data="{ item, searchValues }"></slot>
          </template>
        </el-form-item>
      </el-form>
    </div>
    <div class="">
      <div class="flex">
        <el-button type="primary" @click="handleCheck" class="btn">确认查询</el-button>
        <el-button @click="handleReset">清除条件</el-button>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import utils from 'my-tools-library'

export default {
  props: {
    span: {
      type: [Number, String],
      default: () => 6
    },
    columns: {
      type: Array,
      default: () => []
    },
    default_values: {
      type: Object,
      default: () => {}
    }
  },
  name: 'ComSearch',
  data() {
    return {
      formInline: {
        user: '',
        region: ''
      },
      searchValues: {}
    }
  },
  methods: {
    handleCheck() {
      const params = { ...this.searchValues }
      if (params.date && params.date.length) {
        delete params.date
      }
      this.$emit('confirm', params)
      this.$emit('search', utils.cleanObject(params))
      // console.log('搜索条件 :>> ', utils.cleanObject(params))
    },
    handleReset() {
      this.searchValues = utils.emptyObject(this.searchValues)
      this.handleCheck()
    },
    handleExport() {
      this.$emit('export')
    }
  },
  watch: {
    searchValues: {
      handler(val) {
        if (val) {
          if (val.date && val.date.length) {
            // eslint-disable-next-line prefer-destructuring
            val.beginTime = val.date[0].split(' ').at(0)
            // eslint-disable-next-line prefer-destructuring
            val.endTime = val.date[1].split(' ').at(0)
          } else {
            delete val.beginTime
            delete val.endTime
          }
        }
      },
      deep: true,
      immediate: true
    },
    columns: {
      handler(val) {
        if (val) {
          this.searchValues = {}
        }
      },
      deep: true,
      immediate: true
    },
    default_values: {
      handler(val) {
        if (val) {
          this.searchValues = utils.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.com-search_wrapper {
  padding: 20px 20px 0 20px;
  background: white;
  margin-bottom: 15px;
  border-radius: 10px;

  .btn {
    height: auto;
  }
}
</style>
